<template>
    <ModalFormReport
        :title="title"
        :reasons="reasons"
        :submit-action="onReportSubmit"
        @close="close(reported)"
    />
</template>

<script>
import ModalMixin from '@mixins/modalMixin';
import ModalFormReport from '@components/ModalFormReport';
import { mapGetters } from 'vuex';
import { getDsaReportReasons } from '@/api/backend/dsa';

export default {
    name: 'ModalReportDsa',

    components: {
        ModalFormReport,
    },

    extends: ModalMixin,

    i18nOptions: {
        namespaces: ['xandr'],
    },

    props: {
        reportData: {
            required: true,
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            reasons: [],
            user: sdWindow?.user,
            reported: false,
        };
    },

    computed: {
        ...mapGetters('ad', ['adReportData']),
        title() {
            return this.$t('report.headline');
        },
    },

    async created() {
        const data = await getDsaReportReasons();

        this.reasons = Object.values(data).map((type) => ({
            value: type.id,
            label: type.reason,
            requireComment: true,
        }));
    },

    methods: {
        onReportSubmit({ reason, comment }) {
            return this.$store
                .dispatch('dsa/storeDsaReport', {
                    ...this.reportData,
                    reason_id: reason,
                    reporter_id: this.user.userid,
                    report_comment: comment,
                })
                .then(() => {
                    this.$store.dispatch('flashMessages/showSuccess', {
                        content: this.$t('common:modal.report.success'),
                        progress: { time: 3000, showProgress: false },
                    });
                    this.reported = true;
                    return true;
                })
                .catch((error) => {
                    const { data } = error.response;
                    this.$store.dispatch('flashMessages/showError', {
                        content: data?.error || data?.message,
                        progress: { time: 3000, showProgress: false },
                    });
                    return false;
                });
        },
    },
};
</script>
